import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DialogService } from 'primeng/dynamicdialog';
import { TableModule } from 'primeng/table';
import { CreateStickyLinkComponent } from './create-sticky-link/create-sticky-link.component';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { Article, StickyLink } from '../../../../shared/public-api';

@Component({
  selector: 'article-sticky-link',
  imports: [TableModule, DialogModule, CommonModule, ButtonModule, InputTextModule, FormsModule],
  providers: [DialogService],
  templateUrl: './article-sticky-link.component.html',
  styleUrl: './article-sticky-link.component.scss',
})
export class ArticleStickyLinkComponent {
  @Input() articleModel: Article;
  @Output() articleModelChange = new EventEmitter<Article>();

  dialogService = inject(DialogService);

  createLink(): void {
    this.dialogService
      .open(CreateStickyLinkComponent, {
        width: '50vw',
        header: 'Create a new link',
      })
      .onClose.subscribe((link) => {
        if (link) {
          this.articleModel.stickyLinks.push(link);
        }
      });
  }

  updateLink(link: StickyLink): void {
    this.dialogService.open(CreateStickyLinkComponent, {
      width: '50vw',
      header: 'Create a new link',
      data: {
        link,
      },
    });
  }

  deleteLink(link: StickyLink): void {
    const index = this.articleModel.stickyLinks.indexOf(link);
    this.articleModel.stickyLinks.splice(index, 1);
  }
}
